module.exports = __webpack_public_path__ + "static/media/software_active.36100fc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/software_active.svg
// module id = 1087
// module chunks = 36